/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagesGetApiV3ImagesAccountsAccountAddressTransactionFlowPng } from "../../funcs/imagesGetApiV3ImagesAccountsAccountAddressTransactionFlowPng.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiV3ImagesAccountsAccountAddressTransactionFlowPngRequest$inboundSchema,
};

export const tool$imagesGetApiV3ImagesAccountsAccountAddressTransactionFlowPng:
  ToolDefinition<typeof args> = {
    name:
      "images-get-api-v3-accounts-account-address-transaction-flow-png",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await imagesGetApiV3ImagesAccountsAccountAddressTransactionFlowPng(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
